import styled from 'astroturf/react';
import { Modal } from 'js/design_system/Modal';
import { Body } from 'js/design_system/Body';
import { Heading } from 'js/design_system/Heading';
import React, { useContext } from 'react';
import {
  Paper,
  OpenalexWork,
  FollowableUser,
  News,
  isPaper,
} from '../shared/types';
import PaperAbstract from './PaperAbstract';
import { ImpressionPropsGenerator } from '../ImpressionHelper';
import { ImpressionEntity } from 'js/utils/impressions';
import PaperInteractions from './PaperInteractions';
import useNewsInteractions from '../News/useNewsInteractions';
import { FeedContext } from '../contexts/feed';
import _ModalWrapper from "MultiPaperModal-ModalWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/MultiPaperModal.tsx?styleId=ModalWrapper";
import _ModalHeader from "MultiPaperModal-ModalHeader.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/MultiPaperModal.tsx?styleId=ModalHeader";
import _ModalBody from "MultiPaperModal-ModalBody.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/MultiPaperModal.tsx?styleId=ModalBody";
import _ModalPapers from "MultiPaperModal-ModalPapers.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/MultiPaperModal.tsx?styleId=ModalPapers";
import _RoundedCorners from "MultiPaperModal-RoundedCorners.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/MultiPaperModal.tsx?styleId=RoundedCorners";


const ModalWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "ModalWrapper",
  styles: _ModalWrapper
});

const ModalHeader = /*#__PURE__*/styled(Heading, null, {
  displayName: "ModalHeader",
  styles: _ModalHeader
});

const ModalBody = /*#__PURE__*/styled(Body, null, {
  displayName: "ModalBody",
  styles: _ModalBody
});

const ModalPapers = /*#__PURE__*/styled("div", null, {
  displayName: "ModalPapers",
  styles: _ModalPapers
});

const RoundedCorners = /*#__PURE__*/styled("div", null, {
  displayName: "RoundedCorners",
  styles: _RoundedCorners
});

type Props = News & {
  getUserData: (id: number) => FollowableUser;
  index: number;
};

const PaperWithInteractions = ({
  paper,
  props,
  impressionPropsGen,
}: {
  paper: Paper | OpenalexWork;
  props: Props;
  impressionPropsGen: ImpressionPropsGenerator;
}) => {
  const { newsActions } = useContext(FeedContext);
  const { actions, permissions } = useNewsInteractions({
    ...props,
    work: paper,
    messageText: {
      bookmarkSuccess: 'Saved to library',
      bookmarkFailure: 'Failed to save to library',
      unbookmarkSuccess: 'Removed from library',
      unbookmarkFailure: 'Failed to remove from library',
    },
    ...newsActions,
    setUserFollowing: () => {},
  });

  return (
    <RoundedCorners>
      <PaperAbstract
        work={paper}
        canUseReader={false}
        showReader={() => {}}
        impressionPropsGen={impressionPropsGen()()}
        paperInteractions={
          <PaperInteractions
            work={paper}
            showBookmark={true}
            aiButton={undefined}
            canUseReader={false}
            showReader={() => {}}
            isSnippet={false}
            isBookmarked={!!permissions.isBookmarked}
            onBookmark={actions.bookmarkWork}
            onUnbookmark={actions.unbookmarkWork}
            onExplain={() => {}}
            impressionPropsGen={
              isPaper(paper)
                ? impressionPropsGen(ImpressionEntity.Work, paper.id)()
                : impressionPropsGen(ImpressionEntity.OpenalexWork, paper.id)()
            }
          />
        }
      />
    </RoundedCorners>
  );
};

export function MultiPaperModal({
  open,
  onClose,
  heading,
  body,
  papers,
  impressionPropsGen,
  props,
}: {
  open: boolean;
  onClose: () => void;
  heading: string;
  body: string;
  papers: Array<Paper | OpenalexWork>;
  impressionPropsGen: ImpressionPropsGenerator;
  props: Props;
}) {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalWrapper>
        <ModalHeader size="lg">{heading}</ModalHeader>
        <ModalBody size="lg">{body}</ModalBody>
        <ModalPapers>
          {papers.map((paper) => (
            <PaperWithInteractions
              key={paper.id}
              paper={paper}
              props={props}
              impressionPropsGen={impressionPropsGen}
            />
          ))}
        </ModalPapers>
      </ModalWrapper>
    </Modal>
  );
}
